// src/services/quote.js
import apiClient from './api';

/**
 * Fetches CPQ Quote Templates for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/quote-templates
 */
export async function getCPQQuoteTemplates(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/quote-templates`);
  return response.data;
}
